import { IInputProps } from "@interfaces";
import { useController } from "react-hook-form";
import { Password, PasswordProps } from "primereact/password";

import { Field } from "../../field";

//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.

export interface IPasswordProps
  extends IInputProps,
    Omit<PasswordProps, "name" | "defaultValue"> {}

const $Password = ({
  name,
  label,
  rules,
  disabled,
  helperText,
  defaultValue,
  disabledInput,
  fieldClassName,
  shouldUnregister,
  ...props
}: IPasswordProps) => {
  const { field, fieldState } = useController({
    name,
    rules,
    disabled,
    defaultValue,
    shouldUnregister,
  });

  return (
    // style={{ cursor: disabledInput ? "not-allowed" : "inherit" }}
    <Field
      name={name}
      label={label}
      helperText={helperText}
      className={fieldClassName}
      isRequired={!!rules?.required}
    >
      <Password
        toggleMask
        id={field.name}
        {...field}
        {...props}
        weakLabel="Muy simple"
        disabled={disabledInput}
        invalid={fieldState.invalid}
        mediumLabel="Complejidad media"
        strongLabel="Complejidad fuerte"
        promptLabel="Ingresa una contraseña"
      />
    </Field>
  );
};

export default $Password;
